var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/cart-image.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n\n<span class=\"c-cart__img-outer\" data-qa-cart-icon>\n\n    <svg class=\"c-cart__img\" aria-hidden=\"true\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" overflow=\"visible\">\n\n    \t<path d=\"M14.78 6.49V5.185C14.78 2.601 12.637.5 10 .5S5.22 2.601 5.22 5.184v1.307H0v7.973C0 17.24 2.357 19.5 5.254 19.5h9.493c2.897 0 5.253-2.26 5.253-5.036V6.49zM6.22 5.185C6.22 3.153 7.914 1.5 10 1.5s3.78 1.653 3.78 3.684v1.307H6.22zM19 14.464c0 2.225-1.908 4.036-4.253 4.036H5.254C2.908 18.5 1 16.69 1 14.464V7.49h4.22v2.427h1V7.491h7.56v2.427h1V7.491H19z\"></path>\n\n    </svg>\n\n</span>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/cart-image.j2"] , dependencies)